import { Square } from 'lucide-react'
import { Tooltip } from 'react-tooltip'
import { SessionManager } from '../../utils'

export default function ActionStop(props) {

    const { text, route_name, onClick } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {permission?.some(val => val.sub_action_name === route_name) &&
                <Square size={16} className='action_btn text-danger me-3'
                    onClick={onClick}
                    data-tooltip-id='stop'
                    data-tooltip-content={text}
                    data-tooltip-place="top"
                />
            }

            <Tooltip id='stop' className='bg-danger tooltip_msg' />
        </>
    )
}